import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link
          to="/"
          className="flex items-center gap-2 text-foreground-950 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
        >
          <span className="w-8 h-8 flex items-center justify-center">
            <i className="ri-movie-2-fill text-2xl text-primary-500"></i>
          </span>
          <span className="font-heading text-xl font-bold tracking-wide">
            黄瓜影院
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="px-4 py-2 text-sm text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {cat.label}
            </Link>
          ))}
          <Link
            to="/about"
            className="px-4 py-2 text-sm text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            关于我们
          </Link>
        </div>

        <div className="hidden md:flex items-center gap-3">
          <button className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 hover:bg-background-200 text-foreground-600 hover:text-foreground-900 transition-all duration-200 cursor-pointer" aria-label="搜索">
            <i className="ri-search-line text-lg"></i>
          </button>
        </div>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-all duration-200 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-4 py-3 text-sm text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                {cat.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-4 py-3 text-sm text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}